import { deleteAudioUrl } from '@core/api'
import { httpClient } from '@core/http-client'

export const deleteAudio = (id: string) => {
    return httpClient.delete(deleteAudioUrl(id))
}
